import { Typography, TypographyProps } from '@mui/material';
import moment from 'moment';

import { NullableFormattedDate } from '../../utils/datetimes/formatting';
import { CaptionLabel } from '../labels/CaptionLabel';
import { VerticalStack } from '../utils/linearLayouts';

export function VisitSingleDateDisplay({
    label = true,
    startDate,
    timezone,
    labelProps = {},
    datetimeProps = {},
}: {
    label?: boolean;
    startDate: Date;
    timezone?: string;
    labelProps?: TypographyProps;
    datetimeProps?: TypographyProps;
}) {
    return (
        <VerticalStack>
            {label ? <CaptionLabel {...labelProps}>Visit Date</CaptionLabel> : null}
            <Typography {...datetimeProps}>
                {timezone ? (
                    <NullableFormattedDate date={moment(startDate).tz(timezone)} />
                ) : (
                    <NullableFormattedDate date={moment(startDate)} />
                )}
            </Typography>
        </VerticalStack>
    );
}

export function TentativeDateDisplay({
    tentativeDate,
    dateProps,
    label = true,
    labelProps = {},
}: {
    tentativeDate: Date;
    dateProps?: TypographyProps;
    label?: boolean;
    labelProps?: TypographyProps;
}) {
    return (
        <VerticalStack>
            {label ? <CaptionLabel {...labelProps}>Tentative Date</CaptionLabel> : null}
            <Typography {...dateProps}>
                <NullableFormattedDate date={moment(tentativeDate)} />
            </Typography>
        </VerticalStack>
    );
}
